<template>
  <div class="signup-main-1x first w3-padding-small">
		<!-- <div class="login-header">SIGN UP</div> -->
    <div class="header-1">Welcome. We exist to make planning easier.</div>

		<div class="main-2">
			<form @submit.prevent="signup">
        <div class="w3-center" v-if="auth_state.signup_error_message.length">
          <div
            class="login-error w3-margin-bottom w3-animate-top"
            v-for="(err, index) in auth_state.signup_error_message"  :key="index"
            >{{ err }}<br/>
          </div>
        </div>

				<div class="item">
          <input v-model="email" type="email" class="input" placeholder="Email" value="" required="">
				</div>

        <div class="item">
          <input v-model="password1" type="password" class="input" placeholder="Password" value="" required="">
        </div>

        <div class="item">
          <input v-model="password2" type="password" class="input" placeholder="Confirm Password" value="" required="">
        </div>

        <div class="item">
          <button-spinner
            :is-loading="isLoading"
            :disabled="isLoading"
            :status="status"
            class="button">
              SIGNUP
          </button-spinner>
        </div>

        <div class="w3-center item">
          <hr>
          <label class="label -2">
            <router-link :to="{ name: 'login' }">
              Have an account? Login
            </router-link>
          </label>
        </div>


			</form>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import VueButtonSpinner from 'vue-button-spinner';

export default {
  name: 'Signup',
  data(){
    return {
      username : "",
      email : "",
      password1 : "",
      password2 : "",
      isLoading: false,
      status: '',
    }
  },
  methods: {
    ...mapActions('auth', ['signupUser']),
    ...mapMutations('auth', ['auth_reset']),
    
    signup: function () {
      this.isLoading = true

      let userInfo = {
        username: this.username,
        email: this.email,
        password1: this.password1,
        password2: this.password2,
      }
      this.signupUser(userInfo).then(res => {})
      .catch((err) => {
        this.isLoading = false
      })
    }
  },
  components: {
    'button-spinner': VueButtonSpinner,
  },

  beforeRouteLeave (to, from, next) {
    this.auth_reset('signup')
    next()
  },

  computed: mapGetters('auth', ['auth_state']),

}
</script>

<style scoped>
@import '../assets/css/login.css';
</style>
